import FortnoxIntegrationSection from "./FortnoxIntegrationSection";

const FortnoxFaktureringPage = () => (
	<FortnoxIntegrationSection type="invoice" title="Fortnox fakturering" />
);

export default FortnoxFaktureringPage;
